import { arrowSvg } from "./hint.js";

const introEl = document.getElementById("intro");

export function openIntro() {
  document.getElementById("introArrowUp").innerHTML = arrowSvg("too-low");
  document.getElementById("introArrowDown").innerHTML = arrowSvg("too-high");
  introEl.classList.add("open");
}

export function closeIntro() {
  introEl.classList.remove("open");
  localStorage.setItem("pc_seen_intro", "1");
}

export function initIntro() {
  document.getElementById("introClose").addEventListener("click", closeIntro);
  document.getElementById("introStart").addEventListener("click", closeIntro);
  document.getElementById("howto").addEventListener("click", openIntro);
  introEl.addEventListener("click", (e) => { if (e.target === introEl) closeIntro(); });
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && introEl.classList.contains("open")) closeIntro();
  });
  if (!localStorage.getItem("pc_seen_intro")) openIntro();
}
